// eslint-disable-next-line no-unused-vars
import request from '@/service/http'

export function init () {
  return request({
    url: '/api/pageManagement/init',
    method: 'post',
  })
}

export function initAll () {
  return request({
    url: '/api/pageManagement/initAll',
    method: 'post',
  })
}

export function pageList (data) {
  return request({
    url: '/api/pageManagement/pageList',
    method: 'post',
    data: data,
  })
}

export function addPage (data) {
  return request({
    url: '/api/pageManagement/addPage',
    method: 'post',
    data: data,
  })
}

export function updatePage (data) {
  return request({
    url: '/api/pageManagement/updatePage',
    method: 'post',
    data: data,
  })
}

export function selectOneById (data) {
  return request({
    url: '/api/pageManagement/selectOneById',
    method: 'post',
    data: data,
  })
}

export function apiList (data) {
  return request({
    url: '/api/pageManagement/apiList',
    method: 'post',
    data: data,
  })
}

export function insertApiInfo (data) {
  return request({
    url: '/api/pageManagement/insertApiInfo',
    method: 'post',
    data: data,
  })
}

export function updateApiInfo (data) {
  return request({
    url: '/api/pageManagement/updateApiInfo',
    method: 'post',
    data: data,
  })
}

export function deletePage (data) {
  return request({
    url: '/api/pageManagement/deletePage',
    method: 'post',
    data: data,
  })
}

export function deleteApi (data) {
  return request({
    url: '/api/pageManagement/deleteApi',
    method: 'post',
    data: data,
  })
}
